<template>
  <v-menu
    activator="parent"
    open-on-hover
  >
    <v-list>
      <template
        v-if="showAtsMenu"
      >
        <v-list-item
          link
          @click="openAtsLink"
        >
          <v-list-item-title>
            Open in {{ projectIntegrationType }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          @click="copyAtsLink"
        >
          <v-list-item-title>
            Copy URL to {{ projectIntegrationType }}
          </v-list-item-title>
        </v-list-item>
      </template>

      <template
        v-if="showTapwageMenu"
      >
        <v-list-item
          link
          @click="openTapwageLink"
        >
          <v-list-item-title>
            View on Tapwage
          </v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          @click="openJobBoardLink"
        >
          <v-list-item-title>
            View on Job Board
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useEditor } from '@/stores/editor/editor';
import { useDocumentAtsLink } from '@/stores/document/atsLink';

const {
  projectIntegrationType,
  showAtsMenu,
  showTapwageMenu,
} = storeToRefs(useEditor());

const {
  copyAtsLink,
  openAtsLink,
  openJobBoardLink,
  openTapwageLink,
} = useDocumentAtsLink();
</script>
